<template>
  <transition name="zoom-out" appear>
    <div class="love-map">
      <transition-group name="zoom-in" appear>
        <div class="point" v-for="name in school" :key="name" :class="{ highlight: name === current }" :style="getPosition(schoolList[name])"></div>
      </transition-group>
    </div>
  </transition>
</template>

<script>
  const MAP_WIDTH = 750
  const MAP_HEIGTH = 540

  export default {
    name: 'love-map',
    props: {
      current: {
        type: String,
        default: ''
      },
      school: {
        type: Array,
        default: []
      }
    },
    computed: {
      schoolList () {
        return this.$store.state.map.schoolList
      }
    },
    methods: {
      getPosition ([x, y]) {
        return {
          top: `${(y / MAP_HEIGTH * 100).toFixed(4)}%`,
          left: `${(x / MAP_WIDTH * 100).toFixed(4)}%`
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../assets/scss/vars";

  $map: "https://cdn.llscdn.com/fe-static/lls-with-tfchina/love-map-bJnaQXS3.png";

  .love-map {
    position: relative;
    width: 100%;
    height: 540px;
    background-image: url($map);
    background-size: cover;
    .point {
      position: absolute;
      width: 58px;
      height: 58px;
      margin-top: -29px;
      margin-left: -29px;
      background-color: $darkRed;
      border: 8px solid $white;
      border-radius: 29px;
      box-shadow: 9px 13px 54px 0 rgba(255, 104, 110, 0.77);
      box-sizing: border-box;
      transition-delay: 0.6s;
      &.highlight {
        animation: zoomInOut 0.6s 1.1s ease-in-out;
        animation-direction: alternate-reverse;
        animation-iteration-count: infinite;
      }
    }
  }
  .zoom-in-enter-active {
    transition: transform 0.4s ease-in;
  }
  .zoom-in-enter {
    transform: scale(0)
  }
  .zoom-out-enter-active {
    transition: transform 0.6s ease-out;
  }
  .zoom-out-enter {
    transform: scale(1.5)
  }
  body[data-webp='support'] {
    .love-map {
      background-image: url($map + '?imageMogr2/format/webp');
    }
  }

  @keyframes zoomInOut {
    from {
      transform: scale(1);
    }
    to {
      transform: scale(1.1);
    }
  }
</style>



// WEBPACK FOOTER //
// LoveMap.vue?ebd69eec